import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    this.specialFormats = ["EBook", "Audiobook"];
    this.cacheElements();

    const pageFormatEl = document.querySelector('.visually-hidden[page-format]');
    const currentFormat = pageFormatEl?.getAttribute('page-format')?.trim() || null;
    const activeFormat = this.specialFormats.includes(currentFormat) ? currentFormat : "Paperback";

    this.updateVisibility(activeFormat);
    this.updateProductButtons(activeFormat);

    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    }
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    }
  }

  /**
   * Cache DOM elements used multiple times
   */
  cacheElements() {
    this.narratorsContainer = this.querySelector('[ref="narratorsContainer"]');
    this.widthWrapper = this.querySelector('[ref="widthWrapper"]');
    this.pagesContainer = this.querySelector('[ref="pagesContainer"]');
  }

  /**
   * Show/hide elements based on format
   */
  updateVisibility(format) {
    const normalized = format?.trim().toLowerCase();

    if (this.narratorsContainer) {
      this.narratorsContainer.style.display = normalized === "audiobook" ? "block" : "none";
    }
    if (this.widthWrapper) {
      this.widthWrapper.style.display = ["audiobook", "ebook"].includes(normalized) ? "none" : "block";
    }
    if (this.pagesContainer) {
      this.pagesContainer.style.display = normalized === "audiobook" ? "none" : "block";
    }
  }

  /**
   * Show/hide product buttons and dropdowns based on format
   */
  updateProductButtons(format) {
    const activeFormat = this.specialFormats.includes(format) ? format : "Paperback";

    // Main product buttons
    document.querySelectorAll('.product-button').forEach(btn => {
      btn.style.display = btn.getAttribute('data-format') === activeFormat ? 'block' : 'none';
    });

    // Dropdown <li> links
    document.querySelectorAll('.retailer-links li[data-format]').forEach(item => {
      item.style.display = item.getAttribute('data-format') === activeFormat ? 'block' : 'none';
    });

    // Optional: reset main dropdown button text
    // const mainDropdownBtn = document.querySelector('.main-retailer-btn .dropdown-localization span');
    // if (mainDropdownBtn) mainDropdownBtn.textContent = `Buy from a retailer`;
  }

  /**
   * Handle variant updates from ThemeEvents
   */
  updatePrice = (event) => {
    const { data } = event.detail;
    const { newProduct, html } = data;

    if (newProduct) this.dataset.productId = newProduct.id;
    else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) return;

    // Elements to update
    const selectors = {
      price: '[ref="priceContainer"]',
      priceInfo: '[ref="priceContainerInfo"]',
      sku: '[ref="skuContainer"]',
      isbn: '[ref="isbnContainer"]',
      format: '[ref="formatContainer"]'
    };

    Object.entries(selectors).forEach(([key, selector]) => {
      const newEl = html.querySelector(`product-price ${selector}`);
      const currentEl = this.querySelector(selector);
      if (newEl && currentEl && currentEl.innerHTML !== newEl.innerHTML) {
        currentEl.innerHTML = newEl.innerHTML;
      }
    });

    // Update visibility based on format
    const newFormatEl = html.querySelector('product-price [ref="formatContainer"]');
    if (newFormatEl) {
      const currentFormat = newFormatEl.innerHTML.trim();
      this.updateProductButtons(currentFormat);
      this.updateVisibility(currentFormat);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}